import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(
  state: RootState['moveModalVisible'] = false,
  action: Action,
): RootState['moveModalVisible'] {
  switch (action.type) {
    case 'MOVE_MODAL_VISIBLE_SET': {
      return action.payload
    }

    default:
      return state
  }
}
